import { useState, useEffect } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ConnectCustomMcpModal = ({
    account_id,
    userData,
    show,
    handleClose,
    fetchData,
    selectedMCP
}) => {
    const { t } = useLanguage()
    const { org_id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [isAccepted, setIsAccepted] = useState(false);
    const [fields, setFields] = useState([]);
    const [formData, setFormData] = useState({});
    const [step, setStep] = useState(1);

    useEffect(() => {
        if (!show) {
            setStep(1);
            setIsAccepted(false);
            setErrorMessage({ message: "", display: false });
            setFields([]);
            setFormData({});
        }
    }, [show]);

    const closeModal = () => {
        handleClose();
        setStep(1);
        setErrorMessage({ message: "", display: false });
        setLoading(false);
    };

    const handleStep1 = async () => {
        setLoading(true);
        setErrorMessage({ message: "", display: false });
        const redirect_uri = window.location.origin;
        // if (selectedMCP.id.startsWith("pub-abty")) {
        //     if(selectedMCP.id){
        //         setTimeout(() => {
        //             navigate(`/oauth/${org_id}/${selectedMCP.id}/${selectedMCP.version}`)
        //         }, 2000);
        //     }
        // } else {
            try {
                const response = await fetch(`${GEN_BACKEND_LINK}/get_custom_auth`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        account_id,
                        org_id,
                        email: userData.email,
                        mcp_id: selectedMCP.id,
                        version: selectedMCP.version,
                        redirect_uri
                    }),
                });

                const result = await response.json();
                if (result.status == "success") {
                    if (result.fields) {
                        setFields(result.fields);
                        setStep(2);
                    } else if (result.url) {
                        window.location.href = result.url;
                    } else if (!result.fields) {
                        setStep(2);
                    }
                }
            } catch (err) {
                setLoading(false);
                setErrorMessage({ message: "An error occurred. Please try again.", display: true });
                console.error("Step1 Error:", err);
            } finally {
                setLoading(false)
            }
        // }

    };

    const handleStep2 = async () => {
        setLoading(true);
        setErrorMessage({ message: "", display: false });

        const missingFields = fields
            .filter(f => f.required)
            .filter(f => {
                const value = formData[f.key];
                if (f.type === "multi-select" || f.type === "select") {
                    return !value || value.length === 0;
                }
                return !value || value === "";
            });

        if (missingFields.length > 0) {
            setErrorMessage({
                message: `${t.abilities.fill_field}: ${missingFields[0].label}`,
                display: true
            });
            setLoading(false);
            return;
        }

        if (!isAccepted) {
            setErrorMessage({ message: t.abilities.auth_req, display: true });
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/connect_custom_mcp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    mcp_id: selectedMCP.id,
                    version: selectedMCP.version,
                    fields: formData
                }),
            });

            const result = await response.json();

            if (result.status === "success") {
                setLoading(false);
                fetchData(org_id)
                closeModal();
            } else {
                setErrorMessage({ message: result.message || t.abilities.failed_conn, display: true });
                setLoading(false);
            }
        } catch (err) {
            setErrorMessage({ message: t.abilities.failed_conn, display: true });
            setLoading(false);
            console.error("Step2 Error:", err);
        }
    };

    const handleFieldChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    return (
        <Modal show={show} centered onHide={closeModal} size="md">
            <div className="modal_header">
                <p className="modal_header_title">
                    {selectedMCP?.name}
                    <span>{selectedMCP?.version && `v${selectedMCP?.version}`}</span>
                </p>
            </div>

            {step == 1 && (
                <div className="modal_main_cont">

                    <div className="persona_reg">

                        {selectedMCP?.creator_name && (
                            <div className="item_content_model">
                                <label className="model_label">{t.abilities.creator}</label>
                                <p>{selectedMCP.creator_name}</p>
                            </div>
                        )}

                        {selectedMCP?.system_provider && (
                            <div className="item_content_model">
                                <label className="model_label">{t.abilities.sys_provider}</label>
                                <p>{selectedMCP.system_provider}</p>
                            </div>
                        )}
                    </div>

                    {selectedMCP?.description && (
                        <div className="item_content_model">
                            <label className="model_label">{t.description}</label>
                            <p>{selectedMCP.description}</p>
                        </div>
                    )}

                    {selectedMCP?.env_vars && selectedMCP.env_vars.length > 0 && (
                        <div className="item_content_model">
                            <label className="model_label">{t.abilities.config_req}</label>
                            <div className="config_cont">
                                {selectedMCP.env_vars.map((env_var) => (
                                    <p className="config_cont_pill">
                                        {env_var}
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* {selectedMCP?.tools && selectedMCP?.tools.length > 0 && (
                    <div className="item_content_model">
                        <label className="model_label">Agent Capabilities <button onClick={toggleCapabillities} className="main_mcp_cont_chat_btn"><i className="fa-solid fa-chevron-down"></i></button></label>
                        <div className={`capabilities_cont ${capabilitiesOpen ? "capabilities_cont_open" : ""}`}>
                            {selectedMCP.tools.map((tool, index) => (
                                <div key={index} className="capabilities_cont_row">
                                    <p className="capabilities_cont_row_title">{tool.name}</p>
                                    <p>{tool.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )} */}
                </div>
            )}

            {step === 2 && (
                <div className="modal_main_cont">
                    {fields.map((field, index) => {
                        if (field.type === "select" || field.type === "multi-select") {
                            const options = field.options || [];
                            const selectedValues = formData[field.key] || [];

                            return (
                                <div key={index} className="label_input">
                                    <label className="input_label">{field.label}</label>
                                    <Dropdown drop="up">
                                        <Dropdown.Toggle
                                            as="div"
                                            className="register_form_first fade-in pointer"
                                        >
                                            {selectedValues.length > 0
                                                ? options
                                                    .filter(opt => selectedValues.includes(opt.value))
                                                    .map(opt => opt.label)
                                                    .join(", ")
                                                : `Select`}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="custom_dropdown_menu">
                                            <div className="scrollable_dropdown_cont">
                                                {options.map((opt) => {
                                                    const isSelected = selectedValues.includes(opt.value);

                                                    return (
                                                        <Dropdown.Item
                                                            key={opt.value}
                                                            onClick={() => {
                                                                setFormData(prev => {
                                                                    if (field.type === "select") {
                                                                        // single-select: replace previous value
                                                                        return {
                                                                            ...prev,
                                                                            [field.key]: [opt.value]
                                                                        };
                                                                    } else {
                                                                        // multi-select: toggle value
                                                                        const alreadySelected = prev[field.key]?.includes(opt.value);
                                                                        return {
                                                                            ...prev,
                                                                            [field.key]: alreadySelected
                                                                                ? prev[field.key].filter(v => v !== opt.value)
                                                                                : [...(prev[field.key] || []), opt.value]
                                                                        };
                                                                    }
                                                                });
                                                            }}
                                                            className="settings_link"
                                                        >
                                                            <i>
                                                                {isSelected
                                                                    ? <MdOutlineCheckCircle />
                                                                    : <MdOutlineCircle />}
                                                            </i>
                                                            {opt.label}
                                                        </Dropdown.Item>
                                                    );
                                                })}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            );
                        }

                        return (
                            <div key={index} className="label_input">
                                <label className="input_label">{field.label} <span>({field.endpoint})</span></label>
                                <input
                                    type={field.type}
                                    autoComplete="off"
                                    maxLength={field.length || 200}
                                    value={formData[field.key] || ""}
                                    onChange={(e) => handleFieldChange(field.key, e.target.value)}
                                    className="register_form_first fade-in"
                                />
                            </div>
                        );
                    })}
                    <div className="item_content_model">
                        <label className="model_label">{t.abilities.authorization}</label>
                        <div className="authorization_cont" onClick={(e) => setIsAccepted(e.target.checked)}>
                            <input
                                type="checkbox"
                                id="accept_mcp"
                                checked={isAccepted}
                                onClick={(e) => setIsAccepted(e.target.checked)}
                            />
                            <label htmlFor="accept_mcp">
                                {t.abilities.i_auth}
                            </label>
                        </div>
                    </div>
                </div>
            )}

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        disabled={loading}
                        onClick={step === 1 ? handleStep1 : handleStep2}
                    >
                        {loading ? <Spinner loading={true} /> : step === 1 ? t.next : t.connect}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loading}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConnectCustomMcpModal;